import { useNavigate } from 'react-router';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { RouteEnum } from '@enum/route.enum';
import { StepEnum } from '@enum/step.enum';
import { useStep } from '@hook/common/use-step.hook';

import { ButtonWrapper, Steps, Wrapper } from './application-steps.aside-style';

interface ApplicationStepsAsideProps {
  step?: StepEnum;
}

export const ApplicationStepsAside = ({ step = StepEnum.None }: ApplicationStepsAsideProps) => {
  const { step: currentStep } = useStep();
  const navigate = useNavigate();

  const shouldRenderCancelButton = step !== StepEnum.Connectors && currentStep === StepEnum.Consumer;

  const handleCancel = () => navigate(RouteEnum.Dashboard.path);

  return (
    <Wrapper>
      <Steps
        current={step}
        direction='vertical'
        items={[
          {
            title: 'Create a application',
            // description: 'This is a description.',
          },
          {
            title: 'Enable integrations',
            // description: 'This is a description.',
          },
          {
            title: 'Set up a consumer',
            // description: 'This is a description.',
          },
          {
            title: 'Get started',
            // description: 'This is a description.',
          },
        ]}
      />
      {shouldRenderCancelButton && (
        <ButtonWrapper>
          <Button type={ButtonTypeEnum.Primary} block ghost onClick={handleCancel}>
            CANCEL
          </Button>
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};
